import * as angular from "angular";

import {Observable} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';
import {FirebaseAuthResponseModel} from "./models/firebase-auth-response.model";
import {FirebaseOptions, getApps, initializeApp} from "firebase/app";
import {getDatabase, off, ref} from "firebase/database";
import {getAuth, signInWithCustomToken} from "firebase/auth";
import {FirebaseApp} from "@firebase/app";
import {Database, goOffline, goOnline} from "@firebase/database";
import {IHttpService} from "angular";
import {Messaging} from "@firebase/messaging";

export class FirebaseService {

  public channel: FirebaseAuthResponseModel;
  public firebaseApp: FirebaseApp;
  public database: Database;
  public messaging: Messaging;
  public fcmToken: string;
  public isFirebaseOnline: boolean;

  constructor(private $http: IHttpService, private $q, private apiConfig, private $window) {
  }

  initFirebase(siteId: string) {

   // this.$window.navigator.serviceWorker.register('/assets/firebase-messaging-sw.js');

    const url = this.apiConfig.baseUrl + `/sites/${siteId}/channel`;
    return this.$http.get(url)
      .then((res: any) => {
        this.channel = res.data;

        if (this.channel) {
          this.firebaseApp = this._getOrInitFirebaseApp(this.channel.appName);
          this.database = getDatabase(this.firebaseApp);

          const auth = getAuth(this.firebaseApp);
          return signInWithCustomToken(auth, this.channel.token);
        }

      })
      .catch((error) => {
        console.error('[FirebaseService] initFirebase failed', error);
      })
  }

  // Firebase is now initialized lazily here (instead of eagerly at bootstrap) because the
  // per-site channel response carries the tenant's actual databaseURL - the static
  // apiConfig.firebaseUs/firebaseEu databaseURL is only a fallback.
  private _getOrInitFirebaseApp(region: string) {
    const baseConfig: FirebaseOptions = region === 'US' ? this.apiConfig.firebaseUs : this.apiConfig.firebaseEu;
    const config: FirebaseOptions = {...baseConfig, databaseURL: this.channel.databaseURL || baseConfig.databaseURL};

    // The URL is part of the name so a different tenant (or URL) never reuses a stale app.
    const appName = `${region}|${config.databaseURL}`;
    return getApps().find((app) => app.name === appName) || initializeApp(config, appName);
  }

  destroyFirebase() {
    if (this.channel && this.firebaseApp) {
      const auth = getAuth(this.firebaseApp);

      this.channel = null;
      this.firebaseApp = null;
      this.database = null;

      return auth.signOut();
    } else {
      return this.$q.all([]);
    }
  }

  firebaseGoOnline(): void {
    const dataBase = this.database;
    if (this.isFirebaseOnline) {
      return;
    } else if (dataBase) {

      goOnline(dataBase);
      this.isFirebaseOnline = true;
    } else {
    }
  }

  firebaseGoOffline(): void {
    if (this.database) {
      goOffline(this.database);
      this.isFirebaseOnline = false;
    } else {
    }
  }



}

angular
  .module('bringoz.admin.persistence')
  .service('firebaseService', FirebaseService);
